
import { deTranslations } from './de';
import { enTranslations } from './en';
import { heTranslations } from './he';
import type { Locale } from '../types/language';

export const translations = {
  de: deTranslations,
  en: enTranslations,
  he: heTranslations
} as const;

export type TranslationKeys = keyof typeof deTranslations;

export { type Locale };
